import { useTheme, Box } from '@simplywallst/ui-core';

const Dot = ({
  active,
  onClick,
}: {
  active: boolean;
  onClick?: () => void;
}) => {
  const theme = useTheme();
  return (
    <Box
      onClick={!active ? onClick : undefined}
      cursor={active ? 'auto' : 'pointer'}
      padding="x0_5"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
      >
        <circle
          cx="4"
          cy="4"
          r="4"
          fill={active ? theme.color.brand01 : theme.color.darkGray}
        />
      </svg>
    </Box>
  );
};

export default Dot;
